import React from 'react';

import { type BaseSvgProps, sizeToSvgWidth } from '../../utils';

export const ReconciledTx = ({
  width = sizeToSvgWidth.sm,
  'data-testid': testId,
  backgroundColorHexCode = 'none',
  primaryColorHexCode = 'rgb(var(--colour-main-500))',
}: BaseSvgProps) => (
  <svg
    width={width}
    height={width}
    viewBox="0 0 12 12"
    fill="none"
    className="shrink-0"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="reconciled transaction"
    data-testid={testId}
  >
    <circle cx="6" cy="6" r="6" fill={backgroundColorHexCode} />
    <circle cx="6" cy="6" r="2.5" fill={primaryColorHexCode} />
    <circle
      cx="6"
      cy="6"
      r="5.25"
      fill="none"
      stroke={primaryColorHexCode}
      strokeWidth="1.5"
    />
  </svg>
);
